import { render, staticRenderFns } from "./WelcomeScreen.vue?vue&type=template&id=5cbb9384&"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js&"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports